// FollowUpPage.js
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Form, Nav } from 'react-bootstrap';
import Navbar from '../../../../Shared/AdminNavbar/Navbar';
import baseURL from '../../../../Apiurs/Apiurls';
import axios from 'axios';
import "../../../../Layout/Collapse/Collapse.css";
import "./Followuppage.css";

const FollowUpPage = () => {
  const { leadid } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const followupListRef = useRef(null);

  const [collapsed, setCollapsed] = useState(false);
  const [followups, setFollowups] = useState([]);
  const [note, setNote] = useState('');
  const [status, setStatus] = useState('low');
  const [followupDate, setFollowupDate] = useState('');
  const [error, setError] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [adding, setAdding] = useState(false);

  // Dynamic tab detection
  const path = location.pathname;
  const isOpportunity = path.includes("/a-opp-");
  const isCommentsActive = path.includes("comments");
  const isFollowupActive = path.includes("followup");

  // Fetch follow-ups
  const fetchFollowups = async () => {
    if (!leadid) return;
    setFetching(true);
    try {
      const res = await axios.get(`${baseURL}/api/followupsnew/${leadid}`);
      const sorted = res.data.sort((a, b) => new Date(b.followup_date) - new Date(a.followup_date));
      setFollowups(sorted);
      setError(null);
    } catch (err) {
      console.error("Error fetching follow-ups:", err.response || err.message);
      setError('Failed to fetch follow-ups.');
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchFollowups();
  }, [leadid]);

  const resetForm = () => {
    setNote('');
    setStatus('low');
    setFollowupDate('');
  };

  const handleAddFollowup = async () => {
    if (!note || !followupDate) {
      setError('Note and date are required');
      return;
    }
    setAdding(true);

    const newFollowup = {
      leadid,
      name: "Admin",
      note,
      status,
      followup_date: followupDate
    };

    try {
      const response = await fetch(`${baseURL}/api/followupsnew`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newFollowup)
      });

      if (response.ok) {
        const addedFollowup = await response.json();
        setFollowups(prev => [addedFollowup, ...prev]);
        resetForm();
        setError(null);

        setTimeout(() => {
          if (followupListRef.current) {
            followupListRef.current.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 100);
      } else {
        console.error("Failed to add follow-up");
        setError("Failed to add follow-up.");
      }
    } catch (err) {
      console.error("Error adding follow-up:", err);
      setError("Failed to add follow-up.");
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>

        {/* 🔹 Nav Tabs */}
        <div className="d-flex justify-content-start" style={{ marginLeft: "5%", marginBottom: "15px" }}>
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link
                active={isCommentsActive}
                onClick={() => {
                  if (isOpportunity) navigate(`/a-opp-comments/${leadid}`);
                  else navigate(`/a-comments/${leadid}`);
                }}
                style={{
                  color: isCommentsActive ? "#007bff" : "black",
                  fontWeight: isCommentsActive ? "bold" : "normal"
                }}
              >
                Comments
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={isFollowupActive}
                onClick={() => {
                  if (isOpportunity) navigate(`/a-opp-followup/${leadid}`);
                  else navigate(`/a-followup/${leadid}`);
                }}
                style={{
                  color: isFollowupActive ? "#007bff" : "black",
                  fontWeight: isFollowupActive ? "bold" : "normal"
                }}
              >
                Follow Up
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* Follow-up Form */}
        <div className="comment-form-container">
          <h3 className='comment-form-header' style={{ "--theme-color": "#007bff" }}>Reminder Settings</h3>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Note</Form.Label>
              <Form.Control as="textarea" rows={3} value={note} onChange={e => setNote(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Date & Time</Form.Label>
              <Form.Control type="datetime-local" value={followupDate} onChange={e => setFollowupDate(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select value={status} onChange={e => setStatus(e.target.value)}>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </Form.Select>
            </Form.Group>
            <Button type="button" onClick={handleAddFollowup} disabled={!note || !followupDate || adding}>
              {adding ? 'Adding...' : 'Add Follow Up'}
            </Button>
          </Form>

          {/* Follow-up List */}
          <div
            ref={followupListRef}
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              marginTop: "20px",
              border: "1px solid #ddd",
              padding: "10px",
              borderRadius: "5px",
              backgroundColor: "#f9f9f9"
            }}
          >
            {fetching && <p style={{ fontSize: '14px' }}>Loading follow-ups...</p>}
            {!fetching && followups.length === 0 && <p style={{ fontSize: '14px' }}>No follow-ups found.</p>}
            {followups.map((f, index) => (
              <div key={f.id || index} className="followup-card" style={{
                fontSize: '14px',
                border: "1px solid #ddd",
                borderRadius: "5px",
                padding: "10px",
                marginBottom: "10px",
                backgroundColor: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  <div style={{ flex: "1 1 45%" }}><strong>Note:</strong> {f.note}</div>
                  <div style={{ flex: "1 1 45%" }}><strong>Date:</strong> {new Date(f.followup_date).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</div>
                  <div style={{ flex: "1 1 45%" }}><strong>Status:</strong> {f.status}</div>
                  <div style={{ flex: "1 1 45%" }}><strong>Added by:</strong> {f.name}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-3">
            <Button className="comment-close-btn comment-btn" onClick={() => navigate(-1)}>
              Back
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FollowUpPage;
